// extracted by mini-css-extract-plugin
module.exports = {"loginPage":"styles_loginPage__3Vxzo"};